import { render, staticRenderFns } from "./ContratoModelo.vue?vue&type=template&id=4bb3e33e&scoped=true&"
import script from "./ContratoModelo.vue?vue&type=script&lang=js&"
export * from "./ContratoModelo.vue?vue&type=script&lang=js&"
import style0 from "./ContratoModelo.vue?vue&type=style&index=0&id=4bb3e33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3e33e",
  null
  
)

export default component.exports